import { createSlice } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseURL } from '../services/api';
import {
  fetchFileListI,
  FileI,
  removeFileResponse,
  uploadFileResponseI,
  uploadFilesI,
} from '../interfaces/appealsAPI';
import { constURL } from '../services/enum.services';

interface modalI {
  isOpen: boolean;
  type: string;
}

type resendAppealT = {
  appealId: string;
  email: string;
  type: 'App' | 'Site';
};

type resendAppealResponse = {
  status: boolean;
  message: string;
};

const initialState: modalI = {
  isOpen: false,
  type: 'Site',
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    callModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    setSourceSite: (state) => {
      state.type = 'Site';
    },
    setSourceApp: (state) => {
      state.type = 'App';
    },
    setSourceDuplicate: (state) => {
      state.type = 'Duplicate';
    },
  },
});

export const FilesAPI = createApi({
  reducerPath: 'filesAPI',
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  tagTypes: ['fileList'],
  endpoints: (build) => ({
    fetchFileList: build.query<Array<FileI>, fetchFileListI>({
      query: ({ appealId, type }) => `${constURL.FILE_LIST}?appealId=${appealId}&type=${type}`,
      providesTags: ['fileList'],
    }),
    uploadFile: build.mutation<uploadFileResponseI, uploadFilesI>({
      query: (prop) => ({
        url: `${prop.type === 'Site' ? constURL.UPLOAD_FILES : constURL.UPLOAD_FILES_APP}`,
        method: 'POST',
        body: prop.formData,
      }),
      invalidatesTags: ['fileList'],
    }),
    removeFile: build.mutation<removeFileResponse, string>({
      query: (file_id) => {
        return {
          url: constURL.REMOVE_FILE,
          method: 'POST',
          body: JSON.stringify({ file_id: file_id }),
        };
      },
      invalidatesTags: ['fileList'],
    }),
    resendAppeal: build.mutation<resendAppealResponse, resendAppealT>({
      query: (data: resendAppealT) => {
        return {
          url: constURL.RESEND_APPEAL,
          method: 'POST',
          body: JSON.stringify(data),
        };
      },
    }),
  }),
});

const { actions, reducer } = modalSlice;
export default reducer;
export const { callModal, closeModal, setSourceApp, setSourceSite, setSourceDuplicate } = actions;

export const {
  useFetchFileListQuery,
  useUploadFileMutation,
  useRemoveFileMutation,
  useResendAppealMutation,
} = FilesAPI;